// extracted by mini-css-extract-plugin
export default {"about-content":"About_about-content__-yW3M","photo":"About_photo__ywRpS","text":"About_text__q-vdH"};